import { PAGE_TYPE_CART } from 'shared/consts'
import {
  EXPERIMENT_VARIATION,
  HEADER_SEARCH_BOX_CLICK,
  HEADER_SEARCH_ICON_CLICK,
  HEADER_STICKY_TOGGLE_EXPERIMENT,
} from 'shared/experiments/consts'
import { activateExperiment } from 'shared/experiments/utils/experiments'
import { getExperimentPerTenantOnClient } from 'shared/experiments/utils/tenantBasedExperimentsUtils'
import { bindTrackingEvents } from 'shared/experiments/utils/tracking'
import store from 'shared/store'

export default () => {
  const {
    isEnabled,
    name: experimentName,
    variant,
  } = getExperimentPerTenantOnClient(HEADER_STICKY_TOGGLE_EXPERIMENT)

  const publicRuntimeConfig = store.getState()?.publicRuntimeConfig
  const { pageType = '' } = publicRuntimeConfig?.pageProperties || {}

  if (!isEnabled || pageType === PAGE_TYPE_CART) {
    return
  }

  const eventsTracking = () => {
    bindTrackingEvents([
      {
        selector:
          '.o-HeaderLarge #h-SearchBox #h-SearchBox__input, .o-HeaderSmall .o-HeaderSmall__dummyInput ',
        event: 'click',
        trackingEvent: HEADER_SEARCH_BOX_CLICK,
      },
      {
        selector:
          '.o-HeaderLarge #h-SearchBox [name="query-button"], .o-HeaderSmall [name="searchbox-mobile-search-icon"]',
        event: 'click',
        trackingEvent: HEADER_SEARCH_ICON_CLICK,
      },
    ])
  }

  const setupStickyOnScrollUp = (): void => {
    const headerV3 = document.querySelector(
      '.o-Header--stickyToggleExperimentV3'
    ) as HTMLElement

    if (!headerV3) return

    let lastScrollY = window.scrollY

    const onDirectionScroll = () => {
      const currentScrollY = window.scrollY

      if (currentScrollY < lastScrollY) {
        headerV3.style.position = 'sticky'
      } else {
        headerV3.style.position = 'static'
      }

      lastScrollY = currentScrollY
    }

    window.addEventListener('scroll', onDirectionScroll, { passive: true })
  }

  const onScroll = () => {
    const isExperimentActivated = window.sessionStorage.getItem(experimentName)

    if (!isExperimentActivated) {
      window.sessionStorage.setItem(experimentName, 'true')
      void activateExperiment(experimentName)
    }

    if (variant === EXPERIMENT_VARIATION.V3) {
      setupStickyOnScrollUp()
    }

    window.removeEventListener('scroll', onScroll)
  }

  window.addEventListener('scroll', onScroll, { passive: true })

  eventsTracking()
}
